import { combineReducers } from 'redux';

import { reducer as listPublic } from './listPublicModule';

export default combineReducers({
	listPublic,
});
